export const productsreq="productreq"

export const productsucc="productsucc"
export const productfail="productfail"
